/* Toro deal room: códigos de acceso, filtros y panel de cifras.

   Reparto de responsabilidades:
   · El servidor (Liquid) decide qué operaciones se envían al navegador. Las de
     nivel "restricted" solo se envían a una cuenta con la etiqueta, y ningún
     código las abre.
   · Este archivo solo revela lo que el servidor ya envió, filtra y suma.
     El código viaja en el HTML: ordena la experiencia, no protege nada. */
(function () {
  'use strict';
  var KEY = 'toro-dr-tier';
  var RANK = { open: 1, team: 2, all: 3 };

  function init(root) {
    if (!root || root.__dr) return;
    root.__dr = true;

    var gate = root.querySelector('[data-dr-gate]');
    var room = root.querySelector('[data-dr-room]');
    var grid = root.querySelector('[data-dr-grid]');
    var bar  = root.querySelector('[data-dr-bar]');
    var mBox = root.querySelector('[data-dr-metrics]');
    var fBox = root.querySelector('[data-dr-families]');
    var member = root.getAttribute('data-member') === '1';

    var codes = {
      open: (root.getAttribute('data-code-open') || '').trim(),
      team: (root.getAttribute('data-code-team') || '').trim(),
      all:  (root.getAttribute('data-code-all')  || '').trim()
    };

    var cards = [].slice.call(grid ? grid.querySelectorAll('.toro-dr__card') : []);

    function lang() { return document.documentElement.getAttribute('data-toro-lang') || 'en'; }
    function t(es, pt, en) { var L = lang(); return L === 'es' ? es : L === 'pt' ? pt : en; }
    function esc(s) {
      return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;')
        .replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    /* ── Apertura ───────────────────────────────────────────────────────── */
    function openRoom(rank) {
      if (gate) gate.hidden = true;
      if (room) room.hidden = false;
      cards.forEach(function (c) {
        var tier = c.getAttribute('data-tier') || 'open';
        c.dataset.blocked = (tier === 'team' && rank < RANK.team) ? '1' : '';
      });
      render();
    }

    if (member) {
      openRoom(RANK.all);
    } else {
      try {
        var saved = +sessionStorage.getItem(KEY) || 0;
        if (saved) openRoom(saved);
      } catch (e) {}
    }

    /* ── Puerta ─────────────────────────────────────────────────────────── */
    var input = root.querySelector('[data-dr-code]');
    var send  = root.querySelector('[data-dr-submit]');
    var err   = root.querySelector('[data-dr-error]');

    function match(v) {
      var s = v.toLowerCase();
      if (codes.all  && s === codes.all.toLowerCase())  return RANK.all;
      if (codes.team && s === codes.team.toLowerCase()) return RANK.team;
      if (codes.open && s === codes.open.toLowerCase()) return RANK.open;
      return 0;
    }
    /* El marcador va en los tres idiomas, como el resto del sitio, y el idioma
       se resuelve en cliente con data-toro-lang. */
    function setPlaceholder() {
      if (!input) return;
      var v = input.getAttribute('data-ph-' + lang()) || input.getAttribute('data-ph-en') || '';
      input.placeholder = v;
    }
    setPlaceholder();

    function tryCode() {
      var rank = match((input && input.value || '').trim());
      if (rank) {
        try { sessionStorage.setItem(KEY, String(rank)); } catch (e) {}
        if (err) err.hidden = true;
        openRoom(rank);
        if (room && room.scrollIntoView) room.scrollIntoView({ block: 'start' });
      } else if (err) {
        err.hidden = false;
      }
    }
    if (send) send.addEventListener('click', tryCode);
    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); tryCode(); }
      });
    }

    /* ── Filtros ────────────────────────────────────────────────────────── */
    var state = { segment: '', family: '', industry: '', stage: '', region: '', geo: '', band: '', amtype: '', sort: 'amount' };

    function uniq(attr) {
      var out = [];
      cards.forEach(function (c) {
        var v = (c.getAttribute(attr) || '').trim();
        if (v && out.indexOf(v) < 0) out.push(v);
      });
      return out.sort();
    }

    /* Industria y país se filtran por una clave estable, la inglesa, y se
       muestran en el idioma activo. Antes el desplegable listaba el valor
       crudo del campo, que estaba en español, y quedaba mezclado con el resto
       de la interfaz cuando el sitio estaba en inglés o portugués. */
    /* Un atributo con varias claves separadas por coma. El desplegable respeta
       el orden del mapa de etiquetas, no el alfabético, para que las industrias
       grandes salgan primero. */
    function uniqList(attr, labels) {
      var vistos = {};
      cards.forEach(function (c) {
        (c.getAttribute(attr) || '').split(',').forEach(function (k) {
          k = k.trim();
          if (k) vistos[k] = 1;
        });
      });
      return Object.keys(labels)
        .filter(function (k) { return vistos[k]; })
        .map(function (k) { return [k, labels[k]]; });
    }

    function uniqLabelled(attr) {
      var seen = {}, out = [];
      cards.forEach(function (c) {
        var k = (c.getAttribute(attr) || '').trim();
        if (!k || seen[k]) return;
        seen[k] = 1;
        var label = (c.getAttribute(attr + '-' + lang()) || '').trim() || k;
        out.push([k, label]);
      });
      return out.sort(function (a, b) { return a[1].localeCompare(b[1]); });
    }
    function sel(id, blank, items) {
      return '<select data-f="' + id + '"><option value="">' + esc(blank) + '</option>' +
        items.map(function (x) {
          return '<option value="' + esc(x[0]) + '">' + esc(x[1] || x[0]) + '</option>';
        }).join('') + '</select>';
    }
    function famLabels() {
      return {
        raise:  t('Buscando inversión',  'Procurando investimento',   'Seeking investment'),
        place:  t('Entregando inversión','Entregando investimento',   'Delivering investment'),
        bizdev: t('Desarrollo de negocio','Desenvolvimento de negócio','Business development')
      };
    }
    function segLabels() {
      return {
        investment: t('Inversión', 'Investimento', 'Investment'),
        bizdev: t('Desarrollo de negocio', 'Desenvolvimento de negócio', 'Business development')
      };
    }
    function kindLabels() {
      return {
        raise:       t('en levantamiento',   'em levantamento',      'being raised'),
        acquisition: t('en adquisición',     'em aquisição',         'in acquisition price'),
        project:     t('en costo de proyecto','em custo de projeto', 'in project cost')
      };
    }
    function typeLabels() {
      return {
        raise:       t('Levantamiento de capital', 'Levantamento de capital', 'Fundraising'),
        acquisition: t('Compra o venta de activo', 'Compra ou venda de ativo', 'M&A / asset purchase'),
        project:     t('Financiamiento de proyecto', 'Financiamento de projeto', 'Project finance')
      };
    }
    /* Industrias. Una operación puede pertenecer a varias: un hotel en operación
       es a la vez inmobiliario y hotelería, y un fondo agrícola es inmobiliario y
       agricultura. El orden de esta lista es el orden del desplegable. */
    function indLabels() {
      return {
        realestate: t('Inmobiliario', 'Imobiliário', 'Real estate'),
        hospitality: t('Hotelería', 'Hotelaria', 'Hospitality'),
        retail:     t('Retail', 'Retalho', 'Retail'),
        agriculture: t('Agricultura', 'Agricultura', 'Agriculture'),
        food:       t('Alimentos y bebidas', 'Alimentos e bebidas', 'Food and beverage'),
        consumer:   t('Bienes de consumo', 'Bens de consumo', 'Consumer goods'),
        healthcare: t('Salud', 'Saúde', 'Healthcare'),
        sports:     t('Deporte', 'Desporto', 'Sports'),
        energy:     t('Energía', 'Energia', 'Energy'),
        mobility:   t('Movilidad', 'Mobilidade', 'Mobility'),
        technology: t('Tecnología', 'Tecnologia', 'Technology')
      };
    }
    /* Momento de la compañía. Cambia el riesgo y el tipo de inversionista. */
    function stageLabels() {
      return {
        asset:       t('Activo inmobiliario', 'Ativo imobiliário', 'Real asset'),
        launch:      t('Por lanzar', 'Por lançar', 'Pre-launch'),
        growth:      t('En operación, escalando', 'Em operação, a escalar', 'Operating, scaling'),
        established: t('Establecida, con renta', 'Estabelecida, com renda', 'Established, income producing')
      };
    }
    function regLabels() {
      return {
        africa:   t('África', 'África', 'Africa'),
        latam:    t('Latinoamérica', 'América Latina', 'Latin America'),
        namerica: t('Norteamérica', 'América do Norte', 'North America'),
        europe:   t('Europa', 'Europa', 'Europe'),
        gccmena:  t('Golfo y MENA', 'Golfo e MENA', 'GCC and MENA'),
        apac:     t('Asia Pacífico', 'Ásia-Pacífico', 'Asia Pacific')
      };
    }

    /* Bandas de valor. La última recoge lo que todavía no está convertido a
       dólares, para no meterlo en la banda más baja por tener un cero. */
    var BANDS = [
      { id: 'b1', min: 1,     max: 1e6,      es: 'Hasta US$1m',        pt: 'Até US$1m',           en: 'Up to US$1m' },
      { id: 'b2', min: 1e6,   max: 5e6,      es: 'US$1m a US$5m',      pt: 'US$1m a US$5m',       en: 'US$1m to US$5m' },
      { id: 'b3', min: 5e6,   max: 2e7,      es: 'US$5m a US$20m',     pt: 'US$5m a US$20m',      en: 'US$5m to US$20m' },
      { id: 'b4', min: 2e7,   max: Infinity, es: 'Más de US$20m',      pt: 'Mais de US$20m',      en: 'Over US$20m' },
      { id: 'b0', min: 0,     max: 0,        es: 'Sin convertir a dólares', pt: 'Sem conversão para dólares', en: 'Not yet in dollars' },
      { id: 'bn', min: 0,     max: 0,        es: 'Sin monto declarado',     pt: 'Sem montante declarado',     en: 'No amount stated' }
    ];
    function bandOf(card) {
      if (card.getAttribute('data-noamt') === '1') return 'bn';
      if (card.getAttribute('data-nousd') === '1') return 'b0';
      var n = +card.getAttribute('data-amount') || 0;
      for (var i = 0; i < BANDS.length; i++) {
        var b = BANDS[i];
        if (b.id === 'b0' || b.id === 'bn') continue;
        if (n >= b.min && n < b.max) return b.id;
      }
      return 'b0';
    }
    function bandLabel(id) {
      var L = lang();
      for (var i = 0; i < BANDS.length; i++) {
        if (BANDS[i].id === id) return BANDS[i][L] || BANDS[i].en;
      }
      return id;
    }

    var onBarChange = null;

    /* Un filtro con una sola opción no filtra nada y ocupa espacio.
       Solo se dibuja cuando hay al menos dos valores distintos. */
    function maybe(id, blank, items) {
      if (items.length < 2) return '';
      return sel(id, blank, items);
    }
    function uniqBands() {
      var seen = {}, out = [];
      cards.forEach(function (c) { seen[bandOf(c)] = 1; });
      BANDS.forEach(function (b) { if (seen[b.id]) out.push([b.id, bandLabel(b.id)]); });
      return out;
    }

    function buildBar() {
      if (!bar) return;
      var F = famLabels(), S = segLabels(), R = regLabels();
      bar.innerHTML =
        maybe('segment', t('Toda la segmentación', 'Toda a segmentação', 'All segments'),
              uniq('data-segment').map(function (k) { return [k, S[k] || k]; })) +
        maybe('family', t('Todas las familias', 'Todas as famílias', 'All families'),
              uniq('data-family').map(function (k) { return [k, F[k] || k]; })) +
        maybe('industry', t('Todas las industrias', 'Todas as indústrias', 'All industries'),
              uniqList('data-industries', indLabels())) +
        maybe('stage', t('Todo momento', 'Todo momento', 'All stages'),
              uniq('data-stage').map(function (k) { return [k, stageLabels()[k] || k]; })) +
        maybe('region', t('Todas las regiones', 'Todas as regiões', 'All regions'),
              uniq('data-region').map(function (k) { return [k, R[k] || k]; })) +
        maybe('geo', t('Todos los países', 'Todos os países', 'All countries'),
              uniqLabelled('data-geo')) +
        maybe('band', t('Todos los valores', 'Todos os valores', 'All values'), uniqBands()) +
        maybe('amtype', t('Todo tipo de operación', 'Todo tipo de operação', 'All deal types'),
              uniq('data-amtype').map(function (k) { return [k, typeLabels()[k] || k]; })) +
        '<select data-f="sort"><option value="amount">' +
          esc(t('Orden: monto', 'Ordem: valor', 'Sort: amount')) +
        '</option><option value="name">' +
          esc(t('Orden: nombre', 'Ordem: nome', 'Sort: name')) +
        '</option></select>' +
        '<button type="button" class="toro-dr__clear" data-dr-clear hidden>' +
          esc(t('Limpiar', 'Limpar', 'Clear')) + '</button>' +
        '<span class="toro-dr__count" data-dr-count></span>';

      /* Un solo listener, reemplazado en cada reconstrucción.
         Antes se acumulaba uno por cada cambio de idioma. */
      if (onBarChange) bar.removeEventListener('change', onBarChange);
      onBarChange = function (e) {
        var f = e.target.getAttribute('data-f');
        if (!f) return;
        state[f] = e.target.value;
        render();
      };
      bar.addEventListener('change', onBarChange);

      var clear = bar.querySelector('[data-dr-clear]');
      if (clear) {
        clear.addEventListener('click', function () {
          Object.keys(state).forEach(function (k) { if (k !== 'sort') state[k] = ''; });
          buildBar();
          render();
        });
      }

      Object.keys(state).forEach(function (k) {
        var el = bar.querySelector('[data-f="' + k + '"]');
        if (el && state[k]) el.value = state[k];
      });
    }

    function money(n) {
      if (!n) return 'US$0';
      if (n >= 1e9) return 'US$' + (n / 1e9).toFixed(2).replace(/\.?0+$/, '') + 'b';
      if (n >= 1e6) return 'US$' + (n / 1e6).toFixed(2).replace(/\.?0+$/, '') + 'm';
      if (n >= 1e3) return 'US$' + Math.round(n / 1e3) + 'k';
      return 'US$' + n;
    }

    /* ── Render ─────────────────────────────────────────────────────────── */
    function render() {
      var live = cards.filter(function (c) { return c.dataset.blocked !== '1'; });
      var shown = live.filter(function (c) {
        if (state.segment && c.getAttribute('data-segment') !== state.segment) return false;
        if (state.family  && c.getAttribute('data-family')  !== state.family)  return false;
        if (state.industry) {
          var inds = (c.getAttribute('data-industries') || '').split(',').map(function (x) { return x.trim(); });
          if (inds.indexOf(state.industry) < 0) return false;
        }
        if (state.stage   && c.getAttribute('data-stage')   !== state.stage)   return false;
        if (state.region  && c.getAttribute('data-region')  !== state.region)  return false;
        if (state.geo     && c.getAttribute('data-geo')     !== state.geo)     return false;
        if (state.band    && bandOf(c) !== state.band)                         return false;
        if (state.amtype  && c.getAttribute('data-amtype')  !== state.amtype)  return false;
        return true;
      });
      cards.forEach(function (c) { c.hidden = shown.indexOf(c) < 0; });

      shown.sort(function (a, b) {
        if (state.sort === 'name') {
          /* El nombre visible son tres nodos, uno por idioma, así que su
             textContent los concatena. Se ordena por el atributo. */
          return (a.getAttribute('data-name') || '')
            .localeCompare(b.getAttribute('data-name') || '');
        }
        return (+b.getAttribute('data-amount') || 0) - (+a.getAttribute('data-amount') || 0);
      });
      shown.forEach(function (c) { grid.appendChild(c); });

      var total = 0, pending = 0, restricted = 0, noamt = 0, sectors = {}, geos = {};
      var byKind = { raise: 0, acquisition: 0, project: 0 };
      shown.forEach(function (c) {
        var n = +c.getAttribute('data-amount') || 0;
        total += n;
        var k = c.getAttribute('data-kind') || 'raise';
        if (byKind[k] === undefined) k = 'raise';
        byKind[k] += n;
        if (c.getAttribute('data-nousd') === '1') pending++;
        if (c.getAttribute('data-noamt') === '1') noamt++;
        if (c.getAttribute('data-tier') === 'restricted') restricted++;
        var s = c.getAttribute('data-sector'), g = c.getAttribute('data-geo');
        if (s) sectors[s] = 1;
        if (g) geos[g] = 1;
      });

      /* Un precio de adquisición y un levantamiento de capital no son lo
         mismo. Se muestra un titular y debajo de qué está hecho, en vez de
         mezclarlos en silencio bajo una sola etiqueta. */
      var K = kindLabels(), parts = [];
      ['raise', 'acquisition', 'project'].forEach(function (k) {
        if (byKind[k] > 0) parts.push(money(byKind[k]) + ' ' + K[k]);
      });
      var composition = parts.length > 1 ? parts.join(' · ') : '';

      if (mBox) {
        var rows = [
          [money(total), t('Capital involucrado', 'Capital envolvido', 'Capital involved'),
            [composition,
             pending ? t('Más ' + pending + ' sin convertir a dólares',
                         'Mais ' + pending + ' sem conversão para dólares',
                         pending + ' more pending conversion to dollars') : ''
            ].filter(Boolean).join('. ')],
          [String(shown.length), t('Operaciones', 'Operações', 'Operations'),
            restricted ? restricted + ' ' + t('restringida(s)', 'restrita(s)', 'restricted') : ''],
          [String(Object.keys(sectors).length), t('Sectores', 'Setores', 'Sectors'), ''],
          [String(Object.keys(geos).length), t('Geografías', 'Geografias', 'Geographies'), '']
        ];
        mBox.innerHTML = rows.map(function (x) {
          return '<div class="toro-dr__metric"><b>' + esc(x[0]) + '</b><span>' + esc(x[1]) + '</span>' +
            (x[2] ? '<small>' + esc(x[2]) + '</small>' : '') + '</div>';
        }).join('');
      }

      if (fBox) {
        /* Las familias sin operaciones no se listan. Decir "sin operaciones
           publicadas" tres veces llena el panel de vacío y hace ver corta a la
           cartera. Si mañana hay una operación de esa familia, la fila vuelve
           sola. */
        var F = famLabels();
        var filas = ['raise', 'place', 'bizdev'].map(function (k) {
          var set = live.filter(function (c) { return c.getAttribute('data-family') === k; });
          if (!set.length) return '';
          var sum = set.reduce(function (a, c) { return a + (+c.getAttribute('data-amount') || 0); }, 0);
          return '<li><span class="n">' + esc(F[k]) + '</span><span class="v">' +
            esc(set.length + ' \u00b7 ' + money(sum)) + '</span></li>';
        }).filter(Boolean);
        fBox.innerHTML = filas.join('');
        var famWrap = fBox.closest('.toro-dr__fam');
        if (famWrap) famWrap.hidden = filas.length === 0;
      }

      var active = Object.keys(state).some(function (k) { return k !== 'sort' && state[k]; });
      var clr = root.querySelector('[data-dr-clear]');
      if (clr) clr.hidden = !active;

      var tBox = root.querySelector('[data-dr-types]');
      if (tBox) {
        var TL = typeLabels();
        var by = {};
        shown.forEach(function (c) {
          var k = c.getAttribute('data-amtype') || 'raise';
          by[k] = (by[k] || 0) + (+c.getAttribute('data-amount') || 0);
        });
        tBox.innerHTML = ['raise', 'acquisition', 'project']
          .filter(function (k) { return by[k]; })
          .map(function (k) {
            return '<li><span class="n">' + esc(TL[k]) + '</span><span class="v">' +
              esc(money(by[k])) + '</span></li>';
          }).join('');
      }

      var cnt = root.querySelector('[data-dr-count]');
      if (cnt) cnt.textContent = shown.length + ' / ' + live.length;
      var vis = root.querySelector('[data-dr-visible]');
      if (vis) vis.textContent = live.length + ' / ' + cards.length;
    }

    buildBar();
    render();
    document.addEventListener('toro:lang', function () { setPlaceholder(); buildBar(); render(); });
  }

  function boot() { document.querySelectorAll('[data-toro-dr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
